module.exports = __webpack_public_path__ + "img/field.5066f659.svg";